<div class="bv-security-change-kdf">
  <h2 class="bv-security-section-title">{{ "encKeySettings" | i18n }}</h2>

  @if (!(noLogoutOnKdfChangeFeatureFlag$ | async) && showKdfWarning) {
    <div class="bv-security-warning-banner bv-security-change-kdf__warning" role="alert">
      <bit-icon name="bwi-exclamation-triangle" class="bv-security-warning-banner__icon" />
      <div class="bv-security-warning-banner__content">
        <p class="bv-security-warning-banner__title">{{ "warning" | i18n }}</p>
        <p class="bv-security-warning-banner__message">
          {{ "kdfSettingsChangeLogoutWarning" | i18n }}
        </p>
      </div>
      <button
        type="button"
        bitIconButton="bwi-close"
        buttonType="subtleGhost"
        size="small"
        class="bv-security-warning-banner__close"
        [label]="'close' | i18n"
        (click)="showKdfWarning = false"
      ></button>
    </div>
  }

  <p class="bv-security-page__desc">
    {{ "encryptionKeySettingsHowShouldWeEncryptYourData" | i18n }}
  </p>
  <p class="bv-security-page__desc bv-security-change-kdf__desc-secondary">
    {{ "encryptionKeySettingsIncreaseImproveSecurity" | i18n }}
  </p>

  <form [formGroup]="formGroup" autocomplete="off" class="bv-security-change-kdf__form">
    <div class="bv-security-change-kdf__fields">
      <bit-form-field class="bv-security-kdf-field">
        <bit-label>{{ "kdfAlgorithm" | i18n }}</bit-label>
        <bit-select formControlName="kdf">
          <bit-option
            *ngFor="let option of kdfOptions"
            [value]="option.value"
            [label]="option.name"
          ></bit-option>
        </bit-select>
      </bit-form-field>

      @if (isPBKDF2(kdfConfig)) {
        <bit-form-field formGroupName="kdfConfig" class="bv-security-kdf-field">
          <bit-label>{{ "kdfIterations" | i18n }}</bit-label>
          <input
            bitInput
            type="number"
            formControlName="iterations"
            [min]="PBKDF2_ITERATIONS.min"
            [max]="PBKDF2_ITERATIONS.max"
          />
          <bit-hint>{{ "kdfIterationRecommends" | i18n }}</bit-hint>
        </bit-form-field>
      } @else if (isArgon2(kdfConfig)) {
        <bit-form-field formGroupName="kdfConfig" class="bv-security-kdf-field">
          <bit-label>{{ "kdfMemory" | i18n }}</bit-label>
          <input
            bitInput
            formControlName="memory"
            type="number"
            [min]="ARGON2_MEMORY.min"
            [max]="ARGON2_MEMORY.max"
          />
        </bit-form-field>
      }
    </div>

    @if (isArgon2(kdfConfig)) {
      <div class="bv-security-change-kdf__fields bv-security-change-kdf__fields--argon2">
        <bit-form-field formGroupName="kdfConfig" class="bv-security-kdf-field">
          <bit-label>{{ "kdfIterations" | i18n }}</bit-label>
          <input
            bitInput
            type="number"
            formControlName="iterations"
            [min]="ARGON2_ITERATIONS.min"
            [max]="ARGON2_ITERATIONS.max"
          />
        </bit-form-field>
        <bit-form-field formGroupName="kdfConfig" class="bv-security-kdf-field">
          <bit-label>{{ "kdfParallelism" | i18n }}</bit-label>
          <input
            bitInput
            type="number"
            formControlName="parallelism"
            [min]="ARGON2_PARALLELISM.min"
            [max]="ARGON2_PARALLELISM.max"
          />
        </bit-form-field>
      </div>
    }

    <button
      (click)="openConfirmationModal()"
      type="button"
      buttonType="primary"
      bitButton
      bitFormButton
      class="bv-security-change-kdf__submit-btn"
    >
      {{ "changeKdf" | i18n }}
    </button>
  </form>
</div>

<bit-popover [title]="'encryptionKeySettingsAlgorithmPopoverTitle' | i18n" #algorithmPopover>
  <ul class="tw-mt-2 tw-mb-0 tw-ps-4">
    <li class="tw-mb-2">{{ "encryptionKeySettingsAlgorithmPopoverPBKDF2" | i18n }}</li>
    <li>{{ "encryptionKeySettingsAlgorithmPopoverArgon2Id" | i18n }}</li>
  </ul>
  <div class="tw-mt-4 tw-mb-1">
    <a
      href="https://bitwarden.com/help/kdf-algorithms/"
      bitLink
      target="_blank"
      rel="noreferrer"
      appA11yTitle="{{ 'learnMoreAboutEncryptionAlgorithms' | i18n }}"
      endIcon="bwi-external-link"
    >
      {{ "learnMore" | i18n }}
    </a>
  </div>
</bit-popover>
